import { ExportColumn } from "@app/report-customization/build-reports/interfaces/exportColumns";
import { ReportType } from "@app/report-customization/build-reports/interfaces/reportTypeEnum";
import { BulkProjectTypeEnum } from "@app/shared/enums/bulkProjectTypeEnum";

export { BulkProjectTypeEnum };

export interface BulkTargetingWizardStepProps {
  stepIsValid: (flag: boolean) => void;
}

export interface BulkTargetingApiResponseModel {
  hasExclusions: boolean;
  hasMarketOrProspect: boolean;
  hasTargets: boolean;
  isReadOnly: boolean;
  lineOfBusiness: string;
  projectId: number;
  projectName: string;
  tags: string[];
  templateName: string;
}

export enum BulkTargetingWizardSteps {
  "SelectProjects",
  "ImportList",
  "ConfigureReport",
  "ColumnConfiguration",
}

export interface ImportBulkTargetingFileResponseModel{
  bulkTargetId: number;
  recordCount: number;
  uploadLimitationStatus: number;
}

export enum BulkTargetExistingTargetActionEnum{
    Append = "append",
    Replace = "replace",
}

export interface BulkTargetIncludedReports {
  serviceAreaSpecialtySummaryComparison: boolean;
  serviceAreaSpecialtySummaryComparisonReportCustomizationId?: number;
  opportunitySpecialtySummaryComparison: boolean;
  opportunitySpecialtySummaryComparisonReportCustomizationId?: number;
  serviceAreaChangedGaps: boolean;
  serviceAreaChangedGapsReportCustomizationId?: number;
  opportunityChangedGaps: boolean;
  opportunityChangedGapsReportCustomizationId?: number;
  serviceAreaProviders: boolean;
  serviceAreaProvidersReportCustomizationId?: number;
  opportunityProviders: boolean;
  opportunityProvidersReportCustomizationId?: number;
  distinctServiceAreaProviders: boolean;
  distinctServiceAreaProvidersReportCustomizationId?: number;
  distinctOpportunityProviders: boolean;
  distinctOpportunityProvidersReportCustomizationId?: number;
  volumeTargetProjectDetails: boolean;
  volumeTargetProjectDetailsReportCustomizationId?: number;
  targetUploadFile: boolean;
  includeReportMetadataSummary: boolean;
}

export interface BulkCreateProviderTargetingModel {
  bulkTargetId: number;
  columnConfigurations?: { [reportType: string]: ColumnConfigurationReport };
  customProjectIds: number[];
  emailOnSuccess: boolean;
  existingTargetAction: BulkTargetExistingTargetActionEnum;
  exportName: string;
  formatType: string;
  includedReports?: BulkTargetIncludedReports;
  isDistinctServicingProviderReport: boolean;
  projectType: 'county' | 'zip';
  reasonDescription: string;
  reasonName: string;
  selectedReports: string[];
}

export interface ColumnConfigurationReport {
  columnsEndpoint: () => Promise<ExportColumn[]>,
  key: string,
  reportType: ReportType,
  title: string,
  presetId?: string,
}

export interface ColumnPreset {
  id: string;
  name: string;
  columns?: string[];
  isDefault?: boolean;
}